import type { FaireProductEntity } from "../../entity_types/product";

export const p_41zr0qcfiq: FaireProductEntity = {
  token: "p_41zr0qcfiq",
  type: "product",
  name: "Old English Zodiac Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/e3cbcefbcfe64d6f69e79ed6110b5b0a2a02d547835b38e5bc5cb3755db17b45.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea21aaee13da6a8c4a7e1b1fd1a117082bf7f3d2db15e987078880b2e7bc1be9.png",
    "https://cdn.faire.com/fastly/e154b5b5debc69ed0126d5ae96ef10b10852ba40da3426c8d91c78d34533a6b4.png",
    "https://cdn.faire.com/fastly/2a31c35008629da94f180c8f2546e604401758060805212454ba30b092e46e83.png",
    "https://cdn.faire.com/fastly/26e50333a4a140c5a232373d9d585be6d86d9ea8ebe92d1e217e216767f7dd11.png",
    "https://cdn.faire.com/fastly/6567abba257a7ffbefa9ec1ff5582f345654a8c27403bd8ca39115907faa5490.png",
    "https://cdn.faire.com/fastly/53688495422be5f54e37e44e0f08f4cdbe495675875eac25c2f37d6e01154599.png",
    "https://cdn.faire.com/fastly/3bf28bbd1d159cfa0cee1ca1133c54cc4387251818866846142cf903e72bcc6b.png",
    "https://cdn.faire.com/fastly/d2431456928477a9f05470379e51109d204a1be2aa63e99922d8f8050678127e.png",
    "https://cdn.faire.com/fastly/c792330cbbaafab22fe6e7f8f3da63fd2053712d1ae95bfd28c95837cfe8585b.png",
    "https://cdn.faire.com/fastly/ca45b1cedd49bc6f42b880b5184c8927a505071fb29eade8b5f4b527978533c4.png",
    "https://cdn.faire.com/fastly/ff70e6e4bd22c8b66e6a37b50accb01732f4f047a2e62debdf9c80d80e6db699.png",
  ],
  priceDollars: 7.96,
  description:
    "Now trending: zodiac names in an Old English font. Each zodiac is beautifully lettered in a classy font, made with a dense, high-quality metal. Great to wear on its own or layer with any necklace in your collection!\n\n16 inch chain with 2 inch extender. Stainless steel gold plated. Comes in beautiful Ellison + Y O U N G logo packaging.\n\nStainless steel, 18K gold plated\nLead and Nickel Free\n\nMade in China",
  tags: [],
  msrpDollars: 21.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:44.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
